import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useParams } from 'react-router-dom';
import ContentContainer from '~/src/components/global/ContentContainer';
import Layout from '~/src/components/global/Layout/Index';
import PhotoVideo from '~/src/components/shared/PhotoVideo';
import Urls from '~/src/constants/urls';
import { imgIconLocationPinSvg } from '~/src/images';
import { OtxEvent } from '~/src/models/OtxEvent';
import { OtxFight } from '~/src/models/OtxFight';
import useFetch from '~/src/overtime-lib/src/www/hooks/useFetch';
import './Event.scss';
import Banner from './Event/Banner';
import FightCards from './Event/FightCards';

const _SubwayGiveaway = ({ event }: { event: OtxEvent }) => {
	if (event.otx_number === 15) {
		return (
			<p>
				<a href="https://overtime.box.com/s/44f9vt7g8jix5c43jxa7zihxn5qhqa96">OTX x Subway Giveaway</a>
			</p>
		);
	}
	if (event.otx_number === 16) {
		return (
			<p>
				<a href="/public/Overtime-x-Subway-Giveaway-Rules-(9.18.25)-OTX-16.docx">OTX x Subway Giveaway</a>
			</p>
		);
	}
	return null;
};

const _Info = ({ event }: { event: OtxEvent }) => {
	return (
		<div className="event-info">
			<div className="description">
				{event.description ? (
					<>
						<h2>Info</h2>
						{event.description?.split('\n\n').map((description, index) => {
							return <p key={index}>{description}</p>;
						})}
						<_SubwayGiveaway event={event} />
					</>
				) : null}
			</div>
			<div className="venue">
				{event.venue?.name && (
					<>
						<h2>Venue</h2>
						<div className="location">
							{/* TODO: Find a secure way to use the google maps api without exposing the key to the public */}
							{/* {process.env.GOOGLE_API_KEY && event.latitude && event.longitude ? (
								<div className="map">
									<a href={`https://www.google.com/maps/search/?api=1&query=${event.latitude},${event.longitude}`}>
										<img
											src={`https://maps.googleapis.com/maps/api/staticmap?&markers=color:blue%7Csize:tiny%7C${event.latitude},${event.longitude}&zoom=13&scale=2&format=png&size=160x160&maptype=roadmap&key=${process.env.GOOGLE_API_KEY}`}
										/>
									</a>
								</div>
							) : null} */}

							{event.venue?.image_path && (
								<div className="map">
									<PhotoVideo
										src={`https://images.itsovertime.tv/${event.venue?.image_path}`}
										width={320}
										mobileWidth={160}
									/>
								</div>
							)}

							<div className="address">
								<div className="name">{event.venue?.name}</div>
								{event.venue?.address || event.address ? (
									<>
										<div className="city">
											<img src={imgIconLocationPinSvg} />
											{event.venue?.city || event.city}, {event.venue?.state || event.state}
										</div>
										<div className="street-address">
											{event.venue?.street || event.street}
											<br />
											{event.venue?.city || event.city}, {event.venue?.state || event.state}{' '}
											{event.venue?.zip || event.zip}
										</div>
										<div className="link">
											{event.venue?.website_url ? (
												<a href={event.venue.website_url}>
													View Website <FontAwesomeIcon icon={faArrowRight} />
												</a>
											) : null}
										</div>
									</>
								) : null}
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

const Event = () => {
	const { otx_event_id } = useParams();
	const event = useFetch<OtxEvent>({ url: `${Urls.ApiEvents}/${otx_event_id}`, key: 'otx_event' })?.result.read();
	const allFights = useFetch<OtxFight[]>({ url: Urls.ApiFights, key: 'otx_fights' })?.result.read();
	const tournamentFights = useFetch<OtxFight[]>({
		url: Urls.ApiTournamentFights,
		key: 'otx_fights',
	}).result.read();

	if (!event) {
		return <></>;
	}

	return (
		<Layout title={event.title} className="event-page">
			<ContentContainer>
				<Banner event={event} />
				{/* {event.drawbridge_collection_id && <Photos event={event} />} */}
				<_Info event={event} />
				<FightCards event={event} tournamentFights={tournamentFights} />
			</ContentContainer>
		</Layout>
	);
};

// Note: There can only be one export per page component for hot loading to work
export default Event;
